import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

  return (
    <header>
      <Navbar bg="success" variant="dark" expand="lg" className="navbar-dark">
        <Container>
          <Navbar.Brand as={Link} to="/">Ronaldo Butrus</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link 
                as={Link} 
                to="/" 
                className={location.pathname === '/' ? 'active' : ''}
              >
                Home
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/portfolio" 
                className={location.pathname === '/portfolio' ? 'active' : ''}
              >
                Portfolio
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/work-experience" 
                className={location.pathname === '/work-experience' ? 'active' : ''}
              >
                Work Experience
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/education" 
                className={location.pathname === '/education' ? 'active' : ''}
              >
                Education
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/revision-notes" 
                className={location.pathname === '/revision-notes' ? 'active' : ''}
              >
                Revision Notes
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header; 